import { Tooltip } from "@mui/material";
import { GridCellCheckboxRenderer, type GridRenderCellParams } from "@mui/x-data-grid-premium";
import { use } from "react";
import GridSelectionContext from "./GridSelectionContext.ts";
import { getSelectionLimitMessage } from "./selectionLimit.ts";
import SelectionLimitContext from "./SelectionLimitContext.ts";

interface Props {
  params: GridRenderCellParams;
}

const SelectionCheckboxCell = ({ params }: Props) => {
  const state = use(GridSelectionContext);
  const maxSelectedValues = use(SelectionLimitContext);
  const checkbox = <GridCellCheckboxRenderer {...params} />;
  return state?.isRowSelectionDisabled(params) === true ? (
    <Tooltip title={getSelectionLimitMessage(maxSelectedValues)}>
      <span>{checkbox}</span>
    </Tooltip>
  ) : (
    checkbox
  );
};

export default SelectionCheckboxCell;
